import type { SVGProps } from 'react';

const SvgStayCurrentLandscape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M1 19h22V5H1zM19 7v10H5V7z" />
  </svg>
);
export default SvgStayCurrentLandscape;
